import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { notificationActions } from "../../../../store/notifications"
import { formatDateLocal } from "../../../../lib/script"
import { formatPatientName } from "../../../../lib/patientName"
import { addRelatedCHUSAPatient } from "../../../../lib/fetchApi"
import { caseActions } from "../../../../store/case"

import classes from './FindRelatedChusaPatient.module.css'

export default function AddRelatedPatient({patientData, closeSearch}) {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const addrelatedPatientHandler = async () => {
        
        setLoading(true)
        try {
            let reqBody = {
                related_patients: [patientData.id]
            }        

            let update = await addRelatedCHUSAPatient(userToken, activeCase.case.id, reqBody)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {
                let dispatchBody = {
                    folder: 'chusa_related_patients',
                    arr: update
                }
                dispatch(caseActions.replaceFolder(dispatchBody))
                closeSearch()
            } 
        } finally {
            setLoading(false)
        }
    }

    return <button onClick={addrelatedPatientHandler} className={classes.item_add} disabled={loading} key={patientData.id}>
        <div className='flex-container'>
            <div className={classes.case}>NG{patientData.person_number}</div>
            <div className={classes.name}>{formatPatientName(patientData, { order: 'lastFirst' })}</div>
        </div>
        <div className='flex-container'>
            <div>{formatDateLocal(patientData.incident_date)}</div>
            {loading && <span className="loader dark"></span>} 
        </div> 
    </button>
}